<template>
    <div class="d-content">
    <div class="main-container">
      <!-- Author: Vaishnavi
        Date: 12/12/2019
        Issue Description: Breadcrumb alignment -->
        <div v-show="showPasswordResetModel" >
          <div class="modal custom-modal">
            <div class="modal-content essPasswordReset modal-border-radius">
              <toast-message :message="errmsgEss" type="error" :isToastEnable="toastESS"  @close ="(val) => toastESS = val"/>
           <form >
            <img
                src="@/assets/close.png"
                class="close-img"
                v-on:click="showPasswordResetModelCloase()"
                alt=""
              />
            <div class="reset-title">
          <label>Reset Password</label>
        </div>
          <div>
            <p class="label enterNewPaaword">Enter New Password</p>
            <div class="password">
              <input
                class="input-field"
                name="New Password"
                :type="passwordtype1"
                v-validate="{required:true, regex:confirmPassword,}"
                v-model="formData.newPassword"
              />
              <i class="material-icons pointer" v-on:click="toggleimg()" md-18 md-inactive>{{icon1}}</i>
            </div>
            <span
              class="errorMessage"
              v-show="errors.has('New Password')"
            >{{ errors.first('New Password') }}</span>
            <br />
            <p class="label">Confirm Password</p>
            <div class="password">
              <input
                class="input-field"
                :type="passwordtype2"
                name="Confirm Password"
                v-validate="{required:true,regex:confirmPassword}"
                v-model="formData.confirmedPassword"
              />
              <i class="material-icons pointer" v-on:click="toggleimg2()" md-18 md-inactive>{{icon2}}</i>
            </div>
            <span
              class="errorMessage"
              v-show="errors.has('Confirm Password')"
            >{{ errors.first('Confirm Password') }}</span>
          </div>
  
          <button type="button" class="signin-btn" @click="reGeneratePassword()">Submit</button>
        </form>
            </div>
          </div>
         </div>
         <pop-up-message
              v-if="showSuccessMsg"
              :message="successMessage"
              btnText="Back"
              @back="backFromPopUp()"
            />
         <div>
          <!-- <breadcrumb :list="breadcrumbList" /> -->
        <toast-message :message="errmsg" type="error" :isToastEnable="toast"  @close ="(val) => toast = val"/>
      <tl-header type="h1">
        <div class="main-header">ESS Access Management</div>
      </tl-header>
      <div class="flex-box">
        <div class="filters">
           <!-- <tl-select
            label="Bands"
            labelText="name"
            :v-model="costCenter"
            :options="bandsList[le_id]"
            @change="(val)=>filterParams.bands_id = val.id"/>
            <tl-select
            label="Department"
            labelText="name"
            :options="buTypeList"
            :reduce="department => `${department.departmentName}`"
            @change="(val)=>filterParams.butype_id = val.id"/>
            <tl-select
            label="Grades"
            labelText="name"
            :options="gradesList[le_id]"
            @change="(val)=>filterParams.grade_id = val.id"/>
            <tl-select
            label="Cost Centre"
            labelText="name"
            :options="costCenterList[le_id]"
            @change="(val)=>filterParams.cc_id = val.id"/>
            <tl-select
            label="Designation"
            labelText="name"
            :options="designationList[le_id]"
            @change="(val)=>filterParams.designation_id = val.id"/>
           <btn text="Apply Filters" type="secondary" class="margintop-10" @click="buildQueryParam"/>          -->
           <!-- <emp-filter @applyFilter="buildQueryParam"></emp-filter> -->
        </div>
        </div>
        <!-- <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
            You have only view permission.
        </div> -->
        <div class="search-bar" >
          <tl-search @change="filterData($event)" @blur="filterOnblur($event)" :placeholder="'Search Employee Name'"/>
       </div>

             <data-table
                :columns="employeeTableColumns"
                :tableData="customEmpList"
                :withForm="false"
                @editStart="initEditStart"
                @delete="deleteItem"
                @update="updateItem"
                :showinrow="false"
                :search="search">
                <template v-slot:rowcontent="slotprops">
                   <img class="user-img" v-if="slotprops.value.column.key=='imgSrc' && !slotprops.value.record[slotprops.value.column.key]" src="@/assets/user.svg"/>
                   <img class="sm-img user-img" v-if="slotprops.value.column.key=='imgSrc' && slotprops.value.record[slotprops.value.column.key]" :src="slotprops.value.record[slotprops.value.column.key]"/>
                   <p v-if="slotprops.value.column.key!='imgSrc'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
                   <p v-if="slotprops.value.column.key =='department'">{{slotprops.value.record[slotprops.value.column.key].designation}}</p>
                    <!-- dropdown section starts here -->
                    <div class="action-section " v-if="slotprops.value.column.key=='action'">
                      <img src="@/assets/group-2.png" class="pointer-cursor" @click="dropdown(slotprops.value.record)" alt="actionIcon">
                      <ul class="action-menu" v-show="customEmpList[slotprops.value.index].showDropDown" >
                          <!-- <li><span class="" @click="changeESSStatus(slotprops.value.record)">Enable ESS </span></li> -->
                          <li> <span class="" @click="resetESSPassword(slotprops.value.record)">Reset Password </span></li>
                          <!-- <li><span class="" @click="createESSLogin(slotprops.value.record)">Create ESS Login </span></li> -->
                      </ul>
                    </div>
                   <!-- dropdown section ends here -->
                </template>
  
             </data-table>
    <!-- EMployee Detail Modal -->
    <div class="modal custom-modal" v-if="changeESSStatusModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
            <h3>Change ESS Status</h3>
        </div>
        <div class="modal-body">
          <div class="threeColumnGrid">
             <div class="emp-img">
               <img src="@/assets/user.svg">
             </div>
             <div class="employee-Details">
               <div class="empName">
                 <label>{{this.essStatusModal.fullname}}</label>
               </div>
               <div class="empcode">
                 <label>{{this.essStatusModal.code}}</label>
               </div>
               <div class="empcode">
                 <label>{{this.essStatusModal.offiEmailId}}</label>
               </div>
               <div class="essStatus">
                  <div class="label-text">Ess Status</div>
                  <div class="radio-group radio-margin-top">
                    <input type="radio" id="active" name="Variable" value="active" v-model="essStatusModal.enableEss">
                    <label for="active">Active</label>
                    <input type="radio" id="deactive" name="Variable" value="inactive" v-model="essStatusModal.enableEss">
                    <label for="deactive">DeActive</label>
                  </div>
              </div>
               <div class="essStatus">
                 <div class="label-text">Effective Date</div>
                 <date-picker @datevalue="(val)=>this.essStatusModal.effectiveDate=val" :value="this.essStatusModal.effectiveDate"/>
               </div>
             </div>
          </div>
          <div class="row justify-content-center paddingtop-10p">
              <btn-grp>
                <btn text="Cancel" type="secondary" @click="cancelModal"/>
                <btn text="Save" type="primary" @click="saveModalData"/>
              </btn-grp>
          </div>
        </div>
      </div>
    </div>
  </div>
   </div>
</div>
  </template>
  
  
  <script>
  import { mapState, mapActions, mapGetters } from "vuex";
  import * as config from "@/apis/config.js";
  export default {
    data() {
      return {
        breadcrumbList:[
                {
                  name: "Organisation",
                  url: `/dashboard/${this.$route.params.entity_index}/organisation`
                },
                {
                  name: "Utilities",
                  url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
                },
                {
                  name: "ESS Access Management",
                  url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/essManagement`
                }
          ],
        changeESSStatusModal: false,
        showPasswordResetModel: false,
        showSuccessMsg : false,
        employeeDetails: {},
        search: "",
        toastESS: false,
        errmsgEss:"",
        formData: {},
        toast:false,
        filterParams:{},
        costCenter: "",
        showDropdown: false,
        employeeData: [],
        errmsg: "",
        employeeTableColumns: [
          {
            label: "",
            key: "imgSrc"
          },
          {
            label: "Code",
            key: "code"
          },
          {
            label: "Name",
            key: "name"
          },
          {
            label: "Department",
            key: "department"
          },
          {
            label: "Email ID",
            key: "email_id"
          },
          {
            label: "Location",
            key: "location"
          },
          {
            label: "Status",
            key: "status"
          },
          {
            label: "",
            key: "action"
          }
        ],
        filtersData: [],
        ecode:"",
        customEmpList : [],
        essStatusModal: {},
        passwordtype1: "password",
        passwordtype2: "password",
        icon1: "visibility_off",
        icon2: "visibility_off",
        confirmPassword:null,
        formData: {
          newPassword: "",
          confirmedPassword: ""
        },
        tabs: [
        //     {
        //     // header: 'All'
        // },
      ],
      essManagementValue: false,
      role: "",
      tempArrayList: []
      };
    },
    mounted() {
      //console.log("New component ESS Management mounted.");
      this.getOrgLeIdList();
      this.confirmPassword = config.Regex.PASSWORD;
    },
    activated: function() {
      // this.fetchEmplDetails();
      this.fetchEmployees();
      this.getOrgLeIdList();
      this.confirmPassword = config.Regex.PASSWORD;
    },
    computed: {
      ...mapState({
        globalEmployeeList:state=>state.globalapi.globalemployees.entityWiseData,
        buTypeList:state => state.onboard.butypes.data.data,
        costCenterList:state => state.onboard.cost_centres.data,
        designationList:state=>state.onboard.designations.entityWiseData,
        bandsList:state => state.onboard.salary_bands.data,
        gradesList:state => state.onboard.salary_grades.data
      }),
      orgId() {
        return this.$store.getters["onboard/getOrgId"];
      },
      ...mapGetters({
        getleid: "onboard/legal_entities/legal_entity_ID"
      }),
      le_id() {
        if (this.$route.params.entity_index)
          return this.getleid(this.$route.params.entity_index);
        else return this.getleid(0);
      },
      ...mapState("onboard/organization", {
        orgIds: state => state.id
      }),
      ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.essManagementValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        //   return true 
        // }
      }
    },
    methods: {
      ...mapActions({
        act_departmentList: "onboard/butypes/fetchAll",
        act_grades: "onboard/salary_grades/fetchAll",
        act_fetchCostCenters: "onboard/cost_centres/fetchAll",
        act_designationList: "onboard/designations/fetchAll",
        act_fetchAllEmployees: "globalapi/globalemployees/fetchAll",
        act_fetch: "onboard/employees/fetchEmployeeListESS",
        fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
        act_changeEmployeeESSStatus: "dashboard/oganisation/essManagement/update",
        act_resetEssPassword:"dashboard/organisation/essManagement/resetEssPassword",
      }),
      backFromPopUp(){
      this.showSuccessMsg = false
      },
      showPasswordResetModelCloase(){
         this.showPasswordResetModel = false;
         this.formData.confirmedPassword = "";
         this.formData.newPassword = "";
      },
      toggleimg() {
        try {
          if (this.passwordtype1 == "password") {
            this.passwordtype1 = "text";
            this.icon1 = "visibility";
          } else {
            this.passwordtype1 = "password";
            this.icon1 = "visibility_off";
          }
        } catch (err) {
          this.errmsg = err;
          this.toast = true;
        }
      },
      toggleimg2() {
        try {
          if (this.passwordtype2 == "password") {
            this.passwordtype2 = "text";
            this.icon2 = "visibility";
          } else {
            this.passwordtype2 = "password";
            this.icon2 = "visibility_off";
          }
        } catch (err) {
          this.errmsg = err;
          this.toast = true;
        }
      },
      async reGeneratePassword(){
        try{
             if(this.formData.newPassword === this.formData.confirmedPassword){
                 this.reGeneratePasswordPost()
             }else{
              this.toastESS = true;
              this.errmsgEss = "Password and Confirm Password should be same" ;
             }
        }catch(err){
          this.errmsg = err;
          this.toast = true;
        }
      },
  
       async reGeneratePasswordPost(){
         try{
            let payload ={
              employeeCode:this.ecode,
              le_id:this.le_id,
              password:this.formData.confirmedPassword
            }
            let res = await this.act_resetEssPassword(payload)
             if(res.status){
               this.showPasswordResetModel = false
               this.showSuccessMsg = true
               this.successMessage = "Password Reseted successfully"
             }
         }catch(err){
              this.toastESS = true;
              this.errmsgEss = err ;
         }
       },
      async fetchdesignation() {
        try {
          await this.act_designationList(this.le_id);
        } catch (err) {
          //console.log(err);
          this.toast = true;
          this.errmsg = err;
        }
      },
  
      async searchEmployeesByName(val) {
        //console.log({val});
        try {
          let res = await this.fetchEmployeeByLeAndName({
            le_id: this.le_id,
            key: val
          });
          // this.employeeData = res.data.payload;
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
  
      async selectedEmp(emp) {
        try {
          this.selectedEmployee = emp
          this.empId = emp.id;
          this.empCode = emp.code;
          this.empName = emp.first_name + ' ' + emp.last_name;   // PL_3009
          this.empMail = emp.email_id;
          let res = await this.fetchNonCtcComponents(emp.id);
          this.employeeList = res.data.payload.data;
          // if (this.typeOfLoss) {
          //   this.fetchAll();
          // }
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
  
      async fetchEmployees() {
        this.customEmpList = []
        try {
          let res = await this.act_fetch({ le_id: this.le_id });
          //console.log("Data Employees",res);
          if (res.data.status) {
            //console.log(res.data);
            let empList = [];
            this.totalEmployees = res.data.payload.totalEmpCount;
            res.data.payload.forEach(element => {
              empList.push({
                id: element.employee_id,
                imgSrc: element.photo_url,
                name:
                  element.name +
                  " " +
                  (element.last_name ? element.last_name : ""),
                code: element.code,
                department: element.department,
                email_id: element.email_id,
                location: element.location,
                // location: element.EmployeeOfficial
                //   ? this.getLocationName(element)
                //   : "",   // PL_3031
                // designation: element.EmployeeOfficial
                //   ? this.getDesignationName(element)
                //   : "",    // PL_3031
                status: element.is_ess_enable ? "Active" : "Pending"
              });
            });
  
            this.customEmpList = empList;
            this.tempArrayList = empList;
            //console.log("this.customEmpList  : ", this.customEmpList);
          }
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      },

      filterData(val) {
        try {
          let tempArray = [];
          this.tempArrayList.forEach(element => {
            if (element.name) {
              if (element.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
                tempArray.push(element);
              }
            }
            if (element.code) {
              if (element.code.toUpperCase().indexOf(val.toUpperCase()) > -1) {
                tempArray.push(element);
              }
            }
          });
          if (val) {
            this.customEmpList = tempArray;
          } else {
            this.customEmpList = [...this.tempArrayList];
          }
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },

      filterOnblur(val){
      try {
        let tempArray = [];
        this.tempArrayList.forEach(element => {
          if (element.name) {
            if (element.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
          if (element.code) {
            if (element.code.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
        });
        if (val) {
          this.customEmpList = tempArray;
        } else {
          this.customEmpList = [...this.tempArrayList];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
  
      async fetchEmplDetails() {
        this.customEmpList = []
        try {
          await this.act_fetchAllEmployees({le_id:this.le_id});
          if(this.globalEmployeeList.length){
            for(let employee of this.globalEmployeeList){
              employee['imgSrc'] = require("@/assets/user.svg"),
              employee['showDropDown'] = false;
              employee['action'] = "";
              employee['department'] = employee.officialDetail.department;
              employee['email_id'] = employee.officialDetail.email;
              this.customEmpList.push(employee)
            }
          }
          //console.log('customEmpList',this.customEmpList);
        } catch (err) {
         //console.log(err);
          this.toast = true;
          this.errmsg = err;
        }
      },
  
      cancelModal() {
        this.changeESSStatusModal = false;
        this.essStatusModal = {};
      },
  
      async buildQueryParam(queryParam){
        //console.log('queryparam',queryParam);
        try {
          await this.act_fetchAllEmployees(queryParam)
        } catch (error) {
          //console.log('error',error);
          this.toast = true;
          this.errmsg = error;
        }
      },
      async saveModalData() {
        //console.log("saveModalData:", this.essStatusModal);
        let obj = {
          emp_id: this.essStatusModal.id,
          email_id: this.essStatusModal.offiEmailId,
          status: this.essStatusModal.enableEss,
          effective_date: this.essStatusModal.effectiveDate
        };
        this.changeESSStatusModal = false;
        this.essStatusModal = {};
        //console.log("obj:", obj);
        try {
          let res = await this.act_changeEmployeeESSStatus(obj);
          //console.log("saveModalData:", res);
        } catch (err) {
          //console.log(err);
          this.toast = true;
          this.errmsg = err;
        }
      },
      dropdown(slots) {
        let idx = this.customEmpList.findIndex(obj => {
          return obj.id == slots.id;
        });
        this.customEmpList.forEach((data, index) => {
          if (index !== idx) {
            data.showDropDown = false;
          }
        });
        // //console.log('customEmpList',this.customEmpList);
        if (idx > -1) {
          this.customEmpList[idx].showDropDown = this.customEmpList[idx].showDropDown ? false : true;
            this.customEmpList = [...this.customEmpList]
        }
      },
      routeToMainStep() {
        this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/organisation/` });
      },
      routeToSubStep() {
        this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities` });
      },
      initEditStart(record) {
        //console.log("record", record);
        this.employeeDetails = record;
        this.changeESSStatusModal = true;
      },
      filterData(searchText) {
        this.search = searchText;
      },
      deleteItem(record) {},
      updateItem(record) {},
      essStatusVal(bool) {
        return bool ? "Active" : "In-Active";
      },
      changeESSStatus(record) {
        //console.log("changeESSStatus:", record);
        this.essStatusModal.fullname = record.name;
        this.essStatusModal.code = record.code;
        this.essStatusModal.id = record.id;
        this.essStatusModal.enableEss = record.essStatus;
        this.essStatusModal.offiEmailId = record.email_id;
        this.changeESSStatusModal = true;
      },
  
      resetESSPassword(record) {
        this.ecode ="";
        this.ecode = record.code;
        this.showPasswordResetModel =true;
      },
  
      createESSLogin(record) {
        //console.log("createESSLogin:", record);
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/essLogin`
        });
      },
  
     ...mapActions({
          getOrgLeList: "onboard/organization/getOrgLeIdList",
      }),
  
      async getOrgLeIdList() {
          const org = this.orgIds;
          const le = this.le_id;
          //console.log("Org:",org);
          //console.log("Le ID",le);
          let bodyParams = {};
          let  data = await this.getOrgLeList({
            data: {
              ...bodyParams
            }
          });
          this.role = data.data.user.userRole;
          this.essManagementValue = data.data.user.permissions.ess_management ? true : false;
          //console.log("PL-3406",data);
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  @import "@/scss/dashboard/_variables.scss"; // Common
  @import "@/scss/dashboard/content/_section.scss"; // Content Section
  .nav {
    margin-top: 1.7%;
    color: #555555;
    font-size: 11px;
  }
  .empName label {
    font-size: 16px;
    color: #646464;
    margin-bottom: 4px;
  }
  .empcode label {
    font-size: 14px;
    color: #878787;
  }
  [type="radio"]:not(:checked) + label {
    position: relative;
    padding-left: 21px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #646464;
    margin-right: 32px;
  }
  .main-header {
    color: #6d6d6d;
    margin-top: 37px;
    font-size: 16px;
  }
  .half-width {
    width: 26.7%;
  }
  .filters-section {
    display: flex;
    align-items: flex-end;
    margin-top: 30px;
    // overflow: scroll;
    *:nth-child(1) {
      margin-right: 10px;
    }
  }
  .sm-img {
    width: 35%;
  }
  .ver-line {
    border-right: solid 1px #30b6bc;
    padding-top: 10px;
  }
  .emp-img {
    width: auto;
    text-align: center;
  }
  .component-wrapper {
    padding: 14px;
  }
  .custom-width-100 {
    width: 100px;
  }
  
  .selectdiv {
    select {
      max-width: 200px;
      border-radius: 4px;
      outline: 0;
      font-size: 14px;
      color: #9c9c9c;
      border: 1px solid #dadada;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      /* SVG background image */
      // background: url("@/assets/stroke-1.png");
      background-size: 12px;
      background-position: calc(100% - 10px) center;
      background-repeat: no-repeat;
  
      option {
        color: #9c9c9c;
        font-size: 12px;
      }
    }
    span {
      color: #b3b3b3;
      font-size: 12px;
    }
  }
  .filters-button {
    margin-top: 10px;
    width: 95px;
    height: 35px;
    cursor: pointer;
    font-size: 12px;
    border-radius: 4px;
    color: #555555;
    border: 1px solid #37c6c0;
  }
  .search-bar {
    padding: 0 0px 30px 0px;
    display: flex;
  }
  .essStatus {
    margin: 30px 0px;
    .label-text {
      font-size: 12px;
      font-weight: 500 !important;
      color: #8d8d8d !important;
      height: 15px !important;
    }
  }
  .export-section {
    margin-left: 38%;
    margin-top: 5px;
    align-items: center;
    display: flex;
    justify-content: flex-end;
  }
  .export-button {
    height: fit-content;
    border-radius: 4px;
    font-family: Montserrat;
    font-size: 12px;
    text-align: center;
    border: 1px solid #5d409f;
    color: #5d409f;
    margin-left: 3px;
  }
  .sort-by {
    display: flex;
    margin-left: 1%;
  
    span {
      margin-right: 10px;
      margin-top: 10px;
      color: #b3b3b3;
      font-size: 12px;
    }
  }
  .side-actions {
    margin-left: 10px;
    margin-top: 10px;
    img {
      cursor: pointer;
      margin-right: 5px;
      margin-left: 5px;
    }
  }
  .flex-box {
    display: flex;
    justify-content: space-between;
  }
  
  .action-section {
    margin: 0px;
    text-align: center;
    img {
      width: auto;
    }
    .action-menu {
      top: 0px;
      right: 54px;
      left: -222px;   //ori: -182px
      li {
        padding: 0px;
        padding: 10px 25px;
        font-weight: 500;
        &:not(:last-child) {
          border-bottom: solid 1px #97979759;
        }
      }
    }
  }
  
  .employee-cards {
    padding: 30px 0 0 10px;
  }
  
  .permission-alert-msg {
    background-color: #f8d7da;
    padding: 1rem 1rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-weight: 600;
    color: #842029;
    border: 1px solid transparent;
    border-radius: .25rem;
    border-color: #f5c2c7;
  }
  .user-img {
    width: 35px;
  }
  .modal-border-radius {
    border-radius: 8px;
  }
  .essPasswordReset {
    background-color: white;
    margin: 150px auto 0px auto;
    z-index: 20;
    width: 700px;
    height: 405px;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    padding: 30px 36px 36px 36px;
  }
  .label {
    height: 15px; 
    margin-bottom: 9px;
    font-family: Montserrat;
    font-size: 13px;
    color: #0e0e0e;
  }
  .enterNewPaaword{
      margin-top: 15px;
    }
  .password {
    display: flex;
    i {
      margin-left: -30px;
      margin-top: 10px;
    }
  }
  .input-field {
    width: 100%;
    height: 43px;
    border-radius: 6px;
    padding: 10px;
    outline: 0;
    border: 1px solid #d8d8d8;
    background-color: #ffffff;
  }
  .pointer {
    cursor: pointer;
  }
  .errorMessage {
      color: #e01717;
    }
    .signin-btn {
    margin-top: 50px;
    width: 100%;
    cursor: pointer;
    height: 45px;
    border-radius: 4px;
    color: #fff;
    font-size: 15px;
    border: none;
    box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
    background-color: #5d409f;
  }
  img.close-img {
    float: right;
    cursor: pointer;
    margin-top:9px;
  }
  .reset-title {
    text-align: center;
    font-size: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  </style>
  